import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
